import { createFileRoute } from '@tanstack/react-router'

import { Register } from '~/boundedContext/auth/pages/register'

import { registerSchema } from './-schemas/register-schema'

export const Route = createFileRoute('/auth/register')({
  component: Register,
  validateSearch: search => registerSchema.parse(search),
})
